import React, { useState } from 'react';
import {
  Typography,
  Button,
  TypographyProps,
  Box,
  SxProps,
  ButtonProps,
} from '@mui/material';
import { TP_COLORS } from '../../../../constants';

const boxStyles: SxProps = {
  display: 'flex',
  zIndex: 5,
  position: 'sticky',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  top: { xs: '56px', sm: '64px' },
  minHeight: { xs: '84px', sm: '50px' },
  flexDirection: { xs: 'column', sm: 'row' },
  background: {
    xs: `url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-left.avif') top left/cover no-repeat, ${TP_COLORS.blue.dark}`,
    sm: `url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-shade-left.avif') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-left.avif') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-shade-right.avif') top right/contain no-repeat, url('${process.env.PUBLIC_URL}/images/landingPage/discount-banner-bg-right.avif') top right/contain no-repeat, ${TP_COLORS.gray.darken}`,
  },
};

const typoProps: TypographyProps = {
  variant: 'subtitle1',
  color: TP_COLORS.white,
  textAlign: 'center',
  margin: '8px',
};

const buttonProps: ButtonProps = {
  size: 'small',
  color: 'inherit',
  variant: 'contained',
  sx: {
    color: TP_COLORS.black,
    backgroundColor: TP_COLORS.white,
    fontWeight: '600',
    fontSize: '14px',
    padding: '3px 16px',
    margin: '8px',
    minWidth: '110px',
  },
};

const DiscountBanner: React.FC = () => {
  // State
  const [isCodeCopied, setCodeCopied] = useState<boolean>(false);

  const handleCopyCode = () => {
    window.navigator.clipboard.writeText('DISC15');
    setCodeCopied(true);
  };

  return (
    <Box sx={boxStyles}>
      <Typography {...typoProps}>
        Hurry! 🎉 Just one step away! Use code Disc15 on the payment page to
        grab 15% off premium today!
      </Typography>

      <Button {...buttonProps} onClick={handleCopyCode}>
        {isCodeCopied ? 'Copied' : 'Copy Code'}
      </Button>
    </Box>
  );
};

export default DiscountBanner;
